// Side-effect module: imported first in src/index.js so every later fetch() to
// the backend API carries the X-TOL-Client header.
import { installTolClientFetch } from './tolClientHeader';

try {
  installTolClientFetch();
} catch {
  /* Never block startup over a diagnostics header. */
}
